import { Spinner as BSSpinner } from 'react-bootstrap';

interface Props {
  show: boolean;
  className?: string;
}

export const Spinner = ({ show = false, className }: Props) => {
  if (!show) return null;

  return (
    <div className={className}>
      <BSSpinner animation={'border'} role={'status'}>
        <span className={'sr-only'}>Loading...</span>
      </BSSpinner>
    </div>
  );
};
